import React, { useState } from "react";
import DictTagsService from "../../../services/dict/DictTagsService";
import { withTranslation, useTranslation } from "react-i18next";
import Modal from "../../../constants/Modal";
import { DictTagsDto } from '../../../types/types';

type Props = {
    item: DictTagsDto;
    onDeleteTag: (tagId: string) => void;
    onEditTag: (tagId: string) => void;
};

const Options: React.FC<Props> = ({ item, onDeleteTag, onEditTag }) => {
    const { t } = useTranslation("global");

    const [showModal, setShowModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");

    const openOptionsModal = () => {
        setModalTitle(t("modals.optionsTitle"));
        setShowModal(true);
    };

    const deleteTag = (tagId: string) => {
        
        DictTagsService.deleteDictTag(tagId)
            .then(() => {
                onDeleteTag(tagId);
                setShowModal(false);
            })
            .catch(error => {
                console.error('Error deleting tag:', error);
            });
    };

    return (
        <div>
            <img src="/images/navigation/options.svg" alt="Options" style={{ cursor: "pointer", width: "24px", height: "24px" }} onClick={openOptionsModal} />

            <Modal show={showModal} onClose={() => setShowModal(false)} title={t("table.options")}>
                <div>
                    <div>
                        <button onClick={() => deleteTag(item.dict_id)} className="buttonDelete">
                            {t("buttons.delete")}
                        </button>
                        <p>{t("buttons.delete_tag_description")}<br /><br /></p>
                    </div>
                    <div>
                        <button onClick={() => { onEditTag(item.dict_id); setShowModal(false); }}>
                            {t("buttons.edit")}
                        </button>
                        <p>{t("buttons.edit_tag_description")}</p>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default withTranslation("global")(Options);